import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";

export default function VendorDeliveryPerformance() {
  const navigate = useNavigate();

  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);

      const response = await api.get("/vendors/risk");

      console.log("DELIVERY SUMMARY", response.data);

      setSummary(
        response.data?.dashboard_summary || {}
      );

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-6">
        Loading...
      </div>
    );
  }

  const deliveryScore =
    Number(summary.deliveryScore || 0);

  const totalDeliveries =
    Number(summary.deliveryTotal || 0);

  const onTime =
    Number(summary.onTimeDeliveries || 0);

  const late =
    Number(summary.lateDeliveries || 0);

  return (
    <div className="p-6">

      <h1 className="text-2xl font-bold mb-6">
        Delivery Performance
      </h1>

      <div className="bg-white rounded-xl shadow p-6">

        <div className="text-center mb-6">

          <div className="text-5xl font-bold text-red-500">
            {deliveryScore.toFixed(1)}%
          </div>

          <div className="text-sm text-gray-500">
            On-Time Delivery Rate
          </div>

          <div className="mt-2 text-sm text-gray-600">
            Total Deliveries :
            {" "}
            {totalDeliveries.toLocaleString()}
          </div>

        </div>

        {/* On Time */}

        <div
          onClick={() => {
  console.log("ONTIME CLICKED");
  navigate("/vendor-management/delivery-performance/list?type=ontime");
}}
        >
          <div className="flex justify-between text-sm mb-1">
            <span>On-Time Deliveries</span>

            <span className="font-semibold text-green-600">
              {onTime.toLocaleString()}
            </span>
          </div>

          <div className="h-3 bg-gray-200 rounded">
            <div
              className="h-3 bg-green-500 rounded"
              style={{
                width: `${deliveryScore}%`,
              }}
            />
          </div>
        </div>

        {/* Late */}

        <div
          className="cursor-pointer"
          onClick={() =>
            navigate(
              "/vendor-management/delivery-performance/list?type=late"
            )
          }
        >
          <div className="flex justify-between text-sm mb-1">
            <span>Late Deliveries</span>

            <span className="font-semibold text-red-600">
              {late.toLocaleString()}
            </span>
          </div>

          <div className="h-3 bg-gray-200 rounded">
            <div
              className="h-3 bg-red-500 rounded"
              style={{
                width: `${100 - deliveryScore}%`,
              }}
            />
          </div>
        </div>

      </div>

    </div>
  );
}